import { render, staticRenderFns } from "./BaseViewDetails.vue?vue&type=template&id=2ca2fb1a&scoped=true&"
import script from "./BaseViewDetails.vue?vue&type=script&lang=ts&"
export * from "./BaseViewDetails.vue?vue&type=script&lang=ts&"
import style0 from "./BaseViewDetails.vue?vue&type=style&index=0&id=2ca2fb1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca2fb1a",
  null
  
)

export default component.exports